import { useActiveAuctionQuery } from '../graphql/types';
import { useEffect, useState } from 'react';

const useActiveYear = () => {
  const [activeYear, setActiveYear] = useState(
    new Date().getFullYear().toString()
  );

  const { data } = useActiveAuctionQuery();

  useEffect(() => {
    if (data?.activeAuction) {
      const activeYear = new Date(data.activeAuction.startsAt).getFullYear();
      setActiveYear(activeYear.toString());
    }
  }, [data?.activeAuction]);

  return activeYear;
};

export default useActiveYear;
